import script from "./TrashProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TrashProductModal.vue?vue&type=script&setup=true&lang=js"

import "./TrashProductModal.vue?vue&type=style&index=0&id=2c30e1ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c30e1ee"]])

export default __exports__